const FifthSection = () => {
    return <div className="fifth-section">

        <div className="first-row">
            <div className="first-column">
                <p>DEF PROJECTS</p>
                <p>URBAN PLANNING + ARCHITECTURE</p>
            </div>
            <div className="second-column">
                <p>ON</p>
                <p>PROJECTS</p>
                <p>CONTACTS</p>
            </div>
        </div>

        <div className="second-row">
            <p>PRIVACY & TERMS</p>
        </div>
        <hr />

        <div className="third-row">
            <div className="first-column">
                <p>CONTACT@DEFPROJECTS.COM</p>
                <p>RJ +55 21 2541 6687</p>
            </div>
            <div className="second-column">
                <p>SINCE 1986 © ALL RIGHTS RESERVED</p>
            </div>
        </div>

        {/* <div className="fourth-row">
            <div className="first-column">
                <p>SP +55 11 3544 3000</p>
            </div>
            <div className="second-column">
                <p>Branding: Where.</p>
                <p>Design: jarcos.work</p>
                <p>Dev: programmatic</p>
            </div>
        </div> */}

        <div className="big-def">
            <div className="d">

                <div className="dee-footer">
                    <div className="circle-footer"></div>
                </div>
            </div>
            <div className="e"><p>
                E
            </p>
            </div>
            <div className="f"><p>
                F
            </p>
            </div>
        </div>

    </div>
}

export default FifthSection